var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"saving-indicator"},[_vm._v("\n    "+_vm._s(_vm.$i18n.gt('LABEL_SAVING_INDICATOR'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }